
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class Input extends Vue {
  @Prop({ required: true }) readonly label!: any
  @Prop({ default: '' }) readonly title!: string

  get isRequired() {
    const rules = this.$attrs.rules || []
    if (Array.isArray(rules)) {
      return rules.some((rule: Function) => {
        return typeof rule === 'function' && rule?.name?.includes('required')
      })
    }
    return false
  }

  get listeners() {
    return {
      ...this.$listeners,
      input: (value: string) => {
        this.$emit('input', value)
      },
    }
  }
}
